import MileageAddressListRequest, {
  MileageAddressListRequestOrder,
} from "../../../../api/raily/mileage/address/list/mileage-address-list.request";
import MileageAddressListParams, {
  MileageAddressListParamsOrder,
} from "./mileage-address-list-params";

const createOrder = (
  order: MileageAddressListParamsOrder | undefined,
): MileageAddressListRequestOrder | undefined => {
  switch (order) {
    case MileageAddressListParamsOrder.CREATED_AT_ASC:
      return MileageAddressListRequestOrder.CREATED_AT_ASC;
    case MileageAddressListParamsOrder.CREATED_AT_DESC:
      return MileageAddressListRequestOrder.CREATED_AT_DESC;
    case MileageAddressListParamsOrder.DESCRIPTION_ASC:
      return MileageAddressListRequestOrder.DESCRIPTION_ASC;
    case MileageAddressListParamsOrder.DESCRIPTION_DESC:
      return MileageAddressListRequestOrder.DESCRIPTION_DESC;
    case MileageAddressListParamsOrder.MODIFIED_AT_ASC:
      return MileageAddressListRequestOrder.MODIFIED_AT_ASC;
    case MileageAddressListParamsOrder.MODIFIED_AT_DESC:
      return MileageAddressListRequestOrder.MODIFIED_AT_DESC;
    case MileageAddressListParamsOrder.STREET_ASC:
      return MileageAddressListRequestOrder.STREET_ASC;
    case MileageAddressListParamsOrder.STREET_DESC:
      return MileageAddressListRequestOrder.STREET_DESC;
    case MileageAddressListParamsOrder.TOWN_ASC:
      return MileageAddressListRequestOrder.TOWN_ASC;
    case MileageAddressListParamsOrder.TOWN_DESC:
      return MileageAddressListRequestOrder.TOWN_DESC;
    default:
      return undefined;
  }
};

const create = (
  loadParams: MileageAddressListParams,
): MileageAddressListRequest => {
  return {
    creationEnd: loadParams.creationEnd,
    creationStart: loadParams.creationStart,
    order: createOrder(loadParams.order),
    searchQuery: loadParams.searchQuery,
  };
};

const mileageAddressListParamsFactory = {
  create,
};

export default mileageAddressListParamsFactory;
